import React, { useCallback, useState } from 'react';
import classNames from 'classnames';

import { IconChevron } from '@/components/icons/IconChevron';

import type { Props } from './types';

import styles from './CollapsibleCard.module.scss';

export const CollapsibleCard = (props: Props): JSX.Element => {
  const [isCollapse, setCollapse] = useState<boolean>(props.isCollapseDefault || false);
  const collapseClass = classNames(styles.collapsible_card, {
    [styles.collapsed]: isCollapse,
    [styles.card_nested]: props.isNested,
  });

  const onClick = useCallback((): void => {
    setCollapse(collapseValue => !collapseValue);
  }, [setCollapse]);

  return (
    <section className={classNames(collapseClass, props.classes?.wrapper)} role="region">
      <div
        className={classNames(styles.collapsible_card_head, props.classes?.header)}
        onClick={onClick}
      >
        <h4>{props.title}</h4>
        <span className={styles.space_element} />
        <div className={styles.extra_element}>{props.extra}</div>
        <IconChevron className={styles.chevron} />
      </div>
      <div className={styles.card_contents}>{props.children}</div>
    </section>
  );
};
